import { render, staticRenderFns } from "./WheelPanel.vue?vue&type=template&id=5431f181&"
import script from "./WheelPanel.vue?vue&type=script&lang=js&"
export * from "./WheelPanel.vue?vue&type=script&lang=js&"
import style0 from "./WheelPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports